import { createContext, useContext, useEffect, useState } from "react";
import { CONTENT } from "../content";
import { trackEvent } from "../analytics";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("mbpv-lang") || "cn";
    } catch {
      return "cn";
    }
  });

  const setLang = (l) => {
    try {
      localStorage.setItem("mbpv-lang", l);
    } catch {}
    trackEvent("language_switch", { language: l });
    setLangState(l);
  };

  const t = CONTENT[lang];

  useEffect(() => {
    document.documentElement.lang = lang === "cn" ? "zh-CN" : "en";
    document.title =
      lang === "cn"
        ? "MB PAY VIA — 高消耗虚拟卡专属费率 | Rates From 0.9%"
        : "MB PAY VIA — High Volume Virtual Card Pricing | Rates From 0.9%";
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
